import React from "react";
import { Props } from "./types";

function Icon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 10.781 8.732">
      <g transform="translate(0.65 0.65)">
        <line x2="7.172" strokeLinecap="round" strokeWidth="1.3" />
        <line
          y1="7.172"
          transform="translate(7.172)"
          strokeLinecap="round"
          strokeWidth="1.3"
        />
        <line
          x1="2.049"
          y1="1.537"
          transform="translate(5.123 5.635)"
          strokeLinecap="round"
          strokeWidth="1.3"
        />
        <line
          y1="1.537"
          x2="2.049"
          transform="translate(7.172 5.635)"
          strokeLinecap="round"
          strokeWidth="1.3"
        />
      </g>
    </svg>
  );
}

export { Icon };
